import { render, staticRenderFns } from "./PhysicianList.vue?vue&type=template&id=b0860ffc&scoped=true"
import script from "./PhysicianList.vue?vue&type=script&lang=js"
export * from "./PhysicianList.vue?vue&type=script&lang=js"
import style0 from "./PhysicianList.vue?vue&type=style&index=0&id=b0860ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0860ffc",
  null
  
)

export default component.exports